import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from '../../../apa/Launcher';
import store from "../../../../store";

class LastTouchGetTask extends AbstractRequestTask {
  constructor() {
    super();
    this.user_id = store.getState().user
    && store.getState().user.user_id
      ? store.getState().user.user_id : null;
  }

  getMethod() {
    return "GET";
  }

  getParams() {
    const paramsGlobals = super.getParams();
    const params = {
      authpn: paramsGlobals.authpn,
      authpt: paramsGlobals.authpt,
      device_category: paramsGlobals.device_category,
      device_model: paramsGlobals.device_model,
      device_type: paramsGlobals.device_type,
      device_manufacturer: paramsGlobals.device_manufacturer,
      region: paramsGlobals.region,
      user_token: paramsGlobals.user_token,
    };

    if(this.user_id) {
      params.user_id = this.user_id;
    }

    return Object.assign({}, params);
  }

  getUrl() {
    const http = "http://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/user/v1/lasttouch/get`;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default LastTouchGetTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/last-touch/LastTouchGetTask.js